import * as Yup from "yup"

export const contractValidationSchema = (t) =>
  Yup.object().shape({
    name: Yup.string()
      .required(t("global.customer_name_is_required", "Customer name is required"))
      .max(
        50,
        t(
          "violation.customer_names_can_be_maxium_of_50_char",
          "Customer names can be a maximum of 50 characters long"
        )
      ),
    internNumber: Yup.string()
      .required(t("global.internnr_is_required", "Internal number is required"))
      .max(50, "Internnr får max vara 50 tecken långt"),
    assignmentNr: Yup.string()
      .required(t("violation.contract_number_is_required", "Contract number is required"))
      .max(
        50,
        t(
          "violation.contact_number_can_be_a_maximum_of_50_char",
          "Contract number can be a maximum of 50 characters long."
        )
      ),
    nrOfHours: Yup.string()
      .required(t("global.hours_is_required", "Hours are required"))
      .max(50, t("violation.hours_can_be_a_maximum_of_50", "Hours can be a maximum of 50 characters long")),
    startDate: Yup.string()
      .required(t("global.start_date_is_required", "Start date is required"))
      .max(
        50,
        t("violation.start_date_can_be_a_maximum_of_50", "Start date can be a maximum of 50 characters long")
      ),
    endDate: Yup.string()
      .requiredt("global.end_date_is_required", "End date is required")
      .max(
        50,
        t("violation.end_date_can_be_a_maximum_of_50_char", "End date can be a maximum of 50 characters long")
      )
  })
